// extracted by css-extract-rspack-plugin
export default {"markerClickable":"EbKlzyhKlnomd6Hv","markerDefault":"Yd9C6jBOgyvROG13","marker":"sBBMD6Bs_Xcud7gj","markerInactive":"uqUOSRafkV4Q7Pow","markerActive":"zjMdIlN7POI6t4iE"};